import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data';

import { Appointment } from '@work4all/models/lib/Classes/Appointment.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { settings, useSetting } from '../../../../../../../../settings';

export const useUserAppointments = (userIds: number[], date: Date) => {
  const resourcePlanningIncludeUserAppointments = useSetting(
    settings.resourcePlanningIncludeUserAppointments()
  );

  const req = useMemo<DataRequest>(() => {
    const start = DateTime.fromJSDate(date).startOf('year').toISO();
    const end = DateTime.fromJSDate(date).endOf('year').toISO();

    return {
      data: {
        id: null,
        startDate: null,
        endDate: null,
        title: null,
        userId: null,
        appointmentState: {
          color: null,
          hexColorBackground: null,
          hexColorForeground: null,
          id: null,
          name: null,
        },
      } as Appointment,
      entity: Entities.appointment,
      filter: [
        {
          $and: [
            { startDate: { $gte: start } },
            { endDate: { $lte: end } },
            {
              $or: userIds.map((id) => ({
                userId: {
                  $eq: id,
                },
              })),
            },
          ],
        },
      ],
    };
  }, [date, userIds]);

  return useDataProvider<Appointment>(
    req,
    !resourcePlanningIncludeUserAppointments.value || userIds.length === 0,
    10000
  );
};
